// Process polyfill - must be imported first
import "./polyfills/process";

// scroll bar
import "simplebar/src/simplebar.css";

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
// Import apexcharts and expose globally for react-apexcharts
import ApexCharts from "apexcharts";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { getStore } from "./store";
import { QueryClientProvider } from "@tanstack/react-query";
import { getQueryClient } from "./react-query/queryClient";

// Expose React, PropTypes, and ApexCharts globally for react-apexcharts compatibility
// Simple direct assignment - no complex logic to avoid blocking
if (typeof window !== "undefined") {
  window.React = React;
  window.PropTypes = PropTypes;
  // Handle both default export and direct export
  if (ApexCharts) {
    window.ApexCharts = ApexCharts.default || ApexCharts;
  }
}

// ----------------------------------------------------------------------

ReactDOM.render(
  <Provider store={getStore()}>
    <QueryClientProvider client={getQueryClient()}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
